<template>
  <div id="wrapper">
    <section-header
      :text="$t('partners.title')"
      :back-text="$t('partners.title')"
    />
    <div id="top"></div>
    <transition tag="div">
      <Loading v-if="data === null" />
      <div
        class="partners-wrapper"
        v-if="data"
        v-masonry
        transition-duration="0.3s"
        item-selector=".item"
      >
        <div v-masonry-tile class="item" v-for="item in data" :key="item.id">
          <img :src="item.logo" />
          <a target="_blank" :href="item.url" v-if="item.url">{{
            item.name
          }}</a>
          <span v-if="!item.url">{{ item.name }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SectionHeader from "@/components/SectionHeader";
import Loading from "@/components/Loading";
import VueScrollTo from "vue-scrollto";
export default {
  name: "Partners",
  components: { SectionHeader, Loading },
  data() {
    return {
      data: null,
    };
  },
  methods: {
    scrollToTop() {
      VueScrollTo.scrollTo("#top", 500);
    },
  },
  mounted() {
    this.$http.get("partners/").then((response) => (this.data = response.data));
  },
};
</script>

<style scoped>
.item {
  width: calc(25% - 30px);
  margin: 0 15px 40px;
}

@media (max-width: 991px) {
  .item {
    width: calc(33.33% - 30px);
  }
}

@media (max-width: 767px) {
  .item {
    width: calc(50% - 30px);
  }
}

@media (max-width: 479px) {
  .item {
    width: calc(100% - 30px);
  }
}
</style>
